module.exports = __webpack_public_path__ + "static/waye-logo-black-2@2x-b16261ae0de36efa17fec735b111c433.png";